var exports = {
  "Qs": "AddGuildModal.module__content___aWEzQX",
  "lF": "AddGuildModal.module__footerReveal___aWEzQX",
  "BT": "AddGuildModal.module__landingContainer___aWEzQX",
  "Xg": "AddGuildModal.module__actionButtonsGroup___aWEzQX",
  "uu": "AddGuildModal.module__actionButtons___aWEzQX",
  "hP": "AddGuildModal.module__actionButton___aWEzQX",
  "gE": "AddGuildModal.module__actionIcon___aWEzQX",
  "ZJ": "AddGuildModal.module__actionLabel___aWEzQX",
  "KJ": "AddGuildModal.module__formContainer___aWEzQX",
  "r2": "AddGuildModal.module__iconSection___aWEzQX",
  "ff": "AddGuildModal.module__iconSectionInner___aWEzQX",
  "go": "AddGuildModal.module__iconLabel___aWEzQX",
  "O2": "AddGuildModal.module__iconPreview___aWEzQX",
  "Dp": "AddGuildModal.module__iconImage___aWEzQX",
  "Pz": "AddGuildModal.module__iconPlaceholder___aWEzQX",
  "D_": "AddGuildModal.module__iconActions___aWEzQX",
  "Nu": "AddGuildModal.module__iconButtons___aWEzQX",
  "m5": "AddGuildModal.module__iconError___aWEzQX",
  "I4": "AddGuildModal.module__guidelines___aWEzQX",
  "YC": "AddGuildModal.module__guidelinesLink___aWEzQX",
  "$J": "AddGuildModal.module__templatePreview___aWEzQX",
  "pT": "AddGuildModal.module__templateInfo___aWEzQX",
  "x7": "AddGuildModal.module__templateLabel___aWEzQX",
  "G": "AddGuildModal.module__templateName___aWEzQX",
  "qt": "AddGuildModal.module__templateStats___aWEzQX",
  "W4": "AddGuildModal.module__openApiUrlButton___aWEzQX",
  "OJ": "AddGuildModal.module__verificationNotice___aWEzQX",
};

module.exports = exports;
